import React from 'react';
import { SIGN_GRID, CELL_SIZE, CHART_SIZE, DEFAULT_SIGN_ABBREVS } from './chartConstants';

// Default BAV cell coloring: green (6-8 good), orange (4-5 neutral), red (1-3 bad)
const defaultGetCellColor = (score) => {
  if (score >= 6) return '#e8f5e9';
  if (score >= 4) return '#fff3e0';
  return '#ffebee';
};

const AshtavargaChakra = ({
  scores = [],
  title = 'Ashtavarga',
  ascendantSign = -1,
  highlightSign = -1,
  getCellColor = defaultGetCellColor,
  loc = null,
}) => {
  const SIGN_ABBREVS = (loc && loc.signAbbrevs) || DEFAULT_SIGN_ABBREVS;

  return (
    <div style={{ textAlign: 'center' }}>
      <svg
        viewBox={`0 0 ${CHART_SIZE} ${CHART_SIZE}`}
        width="100%"
        style={{ maxWidth: 420, border: '2px solid #333', background: '#fffef5' }}
      >
        {/* Outer border */}
        <rect x="0" y="0" width={CHART_SIZE} height={CHART_SIZE} fill="none" stroke="#333" strokeWidth="2" />

        {/* Vertical lines */}
        <line x1={CELL_SIZE} y1={0} x2={CELL_SIZE} y2={CHART_SIZE} stroke="#333" strokeWidth="1" />
        <line x1={CELL_SIZE * 2} y1={0} x2={CELL_SIZE * 2} y2={CELL_SIZE} stroke="#333" strokeWidth="1" />
        <line x1={CELL_SIZE * 3} y1={0} x2={CELL_SIZE * 3} y2={CHART_SIZE} stroke="#333" strokeWidth="1" />
        <line x1={CELL_SIZE * 2} y1={CELL_SIZE * 3} x2={CELL_SIZE * 2} y2={CHART_SIZE} stroke="#333" strokeWidth="1" />

        {/* Horizontal lines */}
        <line x1={0} y1={CELL_SIZE} x2={CHART_SIZE} y2={CELL_SIZE} stroke="#333" strokeWidth="1" />
        <line x1={0} y1={CELL_SIZE * 2} x2={CELL_SIZE} y2={CELL_SIZE * 2} stroke="#333" strokeWidth="1" />
        <line x1={CELL_SIZE * 3} y1={CELL_SIZE * 2} x2={CHART_SIZE} y2={CELL_SIZE * 2} stroke="#333" strokeWidth="1" />
        <line x1={0} y1={CELL_SIZE * 3} x2={CHART_SIZE} y2={CELL_SIZE * 3} stroke="#333" strokeWidth="1" />

        {/* Center box */}
        <rect x={CELL_SIZE} y={CELL_SIZE} width={CELL_SIZE * 2} height={CELL_SIZE * 2} fill="none" stroke="#333" strokeWidth="1" />

        {/* Center title */}
        <text x={CELL_SIZE * 2} y={CELL_SIZE * 1.85} textAnchor="middle" fontSize="15" fontWeight="bold" fill="#333">
          {title}
        </text>

        {/* Render each sign cell */}
        {SIGN_GRID.map((pos, signIdx) => {
          const x = pos.col * CELL_SIZE;
          const y = pos.row * CELL_SIZE;
          const score = scores[signIdx] ?? 0;
          const bgColor = getCellColor(score);
          const isAsc = signIdx === ascendantSign;

          return (
            <g key={signIdx}>
              {/* Cell background */}
              {bgColor !== 'transparent' && (
                <rect x={x + 1} y={y + 1} width={CELL_SIZE - 2} height={CELL_SIZE - 2} fill={bgColor} />
              )}

              {/* ASC highlight overlay */}
              {isAsc && (
                <rect
                  x={x + 1} y={y + 1}
                  width={CELL_SIZE - 2} height={CELL_SIZE - 2}
                  fill="#B8860B" fillOpacity="0.15"
                  stroke="#B8860B" strokeWidth="2" strokeDasharray="4,3"
                />
              )}

              {/* Planet sign highlight (grey overlay) */}
              {signIdx === highlightSign && signIdx !== ascendantSign && (
                <rect
                  x={x + 1} y={y + 1}
                  width={CELL_SIZE - 2} height={CELL_SIZE - 2}
                  fill="#607D8B" fillOpacity="0.15"
                  stroke="#607D8B" strokeWidth="1.5" strokeDasharray="6,3"
                />
              )}

              {/* Sign abbreviation (top-left) */}
              <text x={x + 4} y={y + 13} fontSize="11" fill="#888" fontWeight="500">
                {SIGN_ABBREVS[signIdx]}
              </text>

              {/* ASC label */}
              {isAsc && (
                <text x={x + CELL_SIZE - 4} y={y + 12} textAnchor="end" fontSize="8" fill="#B8860B" fontWeight="700">
                  ASC
                </text>
              )}

              {/* Score (centered, large) */}
              <text
                x={x + CELL_SIZE / 2}
                y={y + CELL_SIZE / 2 + 8}
                textAnchor="middle"
                fontSize="28"
                fontWeight="700"
                fill={score >= 6 ? '#2e7d32' : score >= 4 ? '#e65100' : '#c62828'}
              >
                {score}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default AshtavargaChakra;
